import {
  LIST_USER_FAILED,
  LIST_USER_REQ,
  LIST_USER_SUCCESS,
} from "../Constants/userConstant";

export const listUserReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case LIST_USER_REQ: {
      return { loading: true };
    }
    case LIST_USER_SUCCESS: {
      return { loading: false, userRecs: payload };
    }

    case LIST_USER_FAILED: {
      return { loading: false, error: payload };
    }
    default: {
      return state;
    }
  }
};
